import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import ScansOverview from './ScansOverview';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyScanOverview } from './companyScanApi';

/** Company Scans → Overview, scoped to this company. */
const CScansOverview = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyScanOverview(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Scans | Shoorah</title>
      </Helmet>
      <ScansOverview fetcher={fetcher} populationLabel={isB2BFansMode ? 'members' : 'employees'} />
    </div>
  );
};

export default CScansOverview;
